import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

const PERMISSIONS = {
  CAMERA: "CAMERA",
  LOCATION: "LOCATION",
  BLE_SCAN: "BLE_SCAN",
  BLE_CONNECT: "BLE_CONNECT",
  BLE_DISABLED: "BLE_DISABLED",
  NOTIFICATIONS: "NOTIFICATIONS",
}

// Connects to data-controller="native--permissions"
export default class extends BridgeComponent {
  static component = "permissions"
  static values = {
    askForNecessaryPermissions: { type: Boolean, default: false },
  }
  static targets = ["locationWarning", "notificationsWarning", "bleWarning", "blePoweredOffWarning"]

  connect() {
    super.connect()

    if (this.askForNecessaryPermissionsValue) {
      this.checkNecessaryPermissions()
    }
  }

  // Einzelne Permission prüfen
  checkPermissions({ params: { permission } }) {
    const sanitizedPermission = PERMISSIONS[permission]
    if (!sanitizedPermission) {
      console.warn(`Unknown permission: ${permission}`)
      return
    }

    this.send("checkPermissions", { permission: sanitizedPermission }, (message) => {
      const granted = message.data.granted
      const notFound = message.data.permission_not_found

      // Dispatched ein "result" Event mit dem Status
      this.dispatch("result", { granted: granted, notFound: notFound })

      // Auf android Geräten kann es vorkommen, dass eine Berechtigung nicht
      // gefunden wird auf alten Geräten oder wenn die Berechtigung nicht existiert.
      if (notFound) {
        this.dispatch("not-found")
        return
      }

      // Wenn eine Aktion nur bei gewährter Berechtigung ausgeführt werden muss,
      // können wir direkt auf die "granted" oder "denied" Events hören
      if (granted) {
        this.dispatch("granted")
      } else {
        this.dispatch("denied")
      }
    })
  }

  // Die Oxocare Mobile App benötigt Standort, Bluetooth-Scan und Benachrichtigungen um richtig zu funktionieren.
  // Diese Methode prüft den Status dieser Berechtigungen und zeigt entsprechende Warnungen an.
  checkNecessaryPermissions() {
    this.send("checkNecessaryPermissions", {}, (message) => {
      const deniedPermissions = message.data.deniedPermissions || []

      // Standort
      if (this.hasLocationWarningTarget) {
        if (deniedPermissions.includes(PERMISSIONS.LOCATION)) {
          this.locationWarningTarget.classList.remove("d-none")
        } else {
          this.locationWarningTarget.classList.add("d-none")
        }
      }

      // Bluetooth
      if (this.hasBleWarningTarget) {
        if (deniedPermissions.includes(PERMISSIONS.BLE_SCAN)) {
          this.bleWarningTarget.classList.remove("d-none")
        } else {
          this.bleWarningTarget.classList.add("d-none")
        }
      }

      // Bluetooth deaktiviert
      if (this.hasBlePoweredOffWarningTarget) {
        if (deniedPermissions.includes(PERMISSIONS.BLE_DISABLED)) {
          this.blePoweredOffWarningTarget.classList.remove("d-none")
        } else {
          this.blePoweredOffWarningTarget.classList.add("d-none")
        }
      }

      // Benachrichtigungen
      if (this.hasNotificationsWarningTarget) {
        if (deniedPermissions.includes(PERMISSIONS.NOTIFICATIONS)) {
          this.notificationsWarningTarget.classList.remove("d-none")
        } else {
          this.notificationsWarningTarget.classList.add("d-none")
        }
      }
    })
  }
}
